import { styled } from 'styletron-react';
import { rhythm } from '../utils/typography';

export const HeaderContainer = styled('div', {
  margin: `${rhythm(1 / 3)} 0`,
});
